import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AutomataOperationsService } from '@vendasta/automata';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { throwError } from 'rxjs';
import { catchError, finalize, take, tap } from 'rxjs/operators';

interface DialogData {
  automationId: string;
  mainRunId: string;
  entityId: string;
  workflowStepId: string;
  stepExecutionUUID: string;
}

@Component({
  templateUrl: './end-automation-run-dialog.component.html',
  styleUrls: ['./end-automation-run-dialog.component.scss'],
  imports: [CommonModule, TranslateModule, MatDialogModule, GalaxyAlertModule, MatButtonModule],
})
export class EndAutomationRunDialogComponent {
  automationId: string;
  mainRunId: string;
  entityId: string;
  workflowStepId: string;
  stepExecutionUUID: string;

  processing: boolean;

  constructor(
    public dialogRef: MatDialogRef<EndAutomationRunDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private readonly translateService: TranslateService,
    protected readonly snackbarService: SnackbarService,
    private readonly automataOperationsService: AutomataOperationsService,
  ) {
    this.automationId = this.data.automationId;
    this.mainRunId = this.data.mainRunId;
    this.entityId = this.data.entityId;
    this.workflowStepId = this.data.workflowStepId;
    this.stepExecutionUUID = this.data.stepExecutionUUID;
  }

  endRun(): void {
    this.processing = true;
    this.automataOperationsService
      .endAutomationRun(this.automationId, this.mainRunId, this.entityId, this.workflowStepId, this.stepExecutionUUID)
      .pipe(
        take(1),
        catchError((e) => {
          if (e.status === 412) {
            this.snackbarService.openErrorSnack('AUTOMATIONS.END_RUN.ERROR_NO_LONGER_DELAYED', {
              action: this.translateService.instant('AUTOMATIONS.END_RUN.REFRESH_PAGE'),
              duration: 7000,
              actionCallback: () => {
                window.location.reload();
              },
            });
          } else {
            this.snackbarService.openErrorSnack('AUTOMATIONS.END_RUN.ERROR_GENERIC');
          }
          return throwError(() => e);
        }),
        tap(() => {
          this.snackbarService.openSuccessSnack('AUTOMATIONS.END_RUN.SUCCESS');
          this.dialogRef.close(true);
        }),
        finalize(() => (this.processing = false)),
      )
      .subscribe();
  }
}
